import { weclappJson } from './weclappJson';
import { GenIcon } from 'react-icons';

export const WeclappIcon = props => GenIcon(weclappJson)(props);
